import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { variant } from 'styled-system'
import styled from 'styled-components'
import { defaultValues } from 'ui/acro/typography/P'
import { Field as FormikField, ErrorMessage } from 'formik'
import { P } from 'ui/acro/typography/P'
import { Collapse } from 'ui/acro/animations'
import { FieldError } from 'ui/acro/elements'
import { space } from 'styled-system'
import { Box } from 'ui/bend'
import { ResponsiveSVG } from '../elements'
import Question from '../../../../assets/images/question.svg'
import ToolTip from '../../../components_v2/Tooltip/ToolTip'

const Input = styled('input')((props) =>
  variant({
    variants: {
      primary: {
        ...defaultValues,
        color: props.theme.colors.grey6,
        width: '100%',
        maxHeight: '50px',
        background: props.theme.colors.base,
        borderColor: props.theme.colors.grey3,
        borderStyle: 'solid',
        borderWidth: '1px',
        marginTop: '8px',
        padding: '12px 16px 11px 16px',
        transition: 'background .25s ease-in-out, border .25s ease-in-out',
        '&:focus': {
          borderColor: props.theme.colors.primary,
          outline: '0',
          background: '#fff'
        },
        '&:focus + label': {
          top: '1px',
          left: '10px',
          fontSize: '14px',
          opacity: 1,
          background: '#fff',
          padding: '0px 6px',
          display: 'block'
        },
        '&:not(:placeholder-shown) + label': {
          top: '1px',
          left: '10px',
          fontSize: '14px',
          opacity: 1,
          background: '#fff',
          padding: '0px 6px',
          display: 'block'
        },
        '&.error': {
          borderColor: props.theme.colors.errorDefault
        }
      }
    }
  })
)

const Label = styled(P)``

Label.defaultProps = {
  as: 'label',
  variant: 'semibold',
  position: 'absolute',
  transition: '0.8s ease all',
  left: '55px',
  top: '56px',
  fontFamily: 'Proxima-Nova',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.352px',
  color: '#636363',
  display: 'none'
}

Input.defaultProps = {
  variant: 'primary'
}

const FieldSet = styled('fieldset')`
  ${space}
  padding: 0;
  border: none;
  position: relative;
  width: ${(props) => props.width};
  .error {
    p {
      margin: 0;
    }
    div {
      height: auto;
    }
  }
`

FieldSet.defaultProps = {
  mb: '12px',
  mt: '0',
  mx: '0'
}

const FloatingLabelInput = ({
  children,
  label,
  name,
  autoComplete,
  autoFocus,
  errors,
  touched,
  onBlur = () => {},
  handleChange,
  onKeyDown,
  placeHolder,
  width = '100%',
  maxLength = 524288,
  isToolTip = false,
  toolTipText
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const hasError = !!(errors[name] && touched[name])

  return (
    <FieldSet width={width}>
      <Input
        as={FormikField}
        type='text'
        name={name}
        className={hasError && 'error'}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        onKeyUp={handleChange}
        onKeyDown={onKeyDown}
        placeholder={isFocused ? '' : placeHolder}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => {
          onBlur(e)
          setIsFocused(false)
        }}
        id={name}
        maxLength={maxLength}
      />
      <Label for={name}> {placeHolder && placeHolder}</Label>
      {isToolTip && (
        <ToolTip content={toolTipText} direction='top'>
          <Box
            position='absolute'
            top='-15px'
            right='4%'
            cursor='pointer'
            padding='0 13px 0 0'
            zIndex='1'
          >
            <ResponsiveSVG SVG={Question} width='20px' height='20px' />
          </Box>
        </ToolTip>
      )}
      <Collapse isOpened={hasError}>
        <ErrorMessage className='error' name={name} component={FieldError} />
      </Collapse>

      {children}
    </FieldSet>
  )
}

FloatingLabelInput.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  handleChange: PropTypes.func,
  // Formik props:
  errors: PropTypes.object,
  touched: PropTypes.object
}

export default FloatingLabelInput
